import render from './render'

export default {
  name: 'Title',

  props: {
    value: {
      type: String,
      default: undefined
    }
  },

  render
}
